import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-allpets',
  templateUrl: './allpets.component.html',
  styleUrl: './allpets.component.scss'
})

export class AllpetsComponent {
    constructor(
      private router: Router,
  
    ) {
  
  
    }
  byPet(pet:any,petId: any) {
      this.router.navigate(['/pet',pet,petId]);

  }
}
